import { render, staticRenderFns } from "./ValueAssessmentCard.vue?vue&type=template&id=6317ac8a&scoped=true"
import script from "./ValueAssessmentCard.vue?vue&type=script&lang=js"
export * from "./ValueAssessmentCard.vue?vue&type=script&lang=js"
import style0 from "./ValueAssessmentCard.vue?vue&type=style&index=0&id=6317ac8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6317ac8a",
  null
  
)

export default component.exports